var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warning",staticStyle:{"padding":"0 1em","text-align":"left","min-height":"20em"}},[_vm._v(" 請注意~無可執行功能 ")])}
var staticRenderFns = []

export { render, staticRenderFns }